import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { DiscussionEmbed } from 'disqus-react';
import ConfigContext from '../../../contexts/ConfigContext';

function DisqusReviews({ truck, location }) {
  const { href, disqus_shortname } = useContext(ConfigContext);

  let disqusConfig = {};
  if (truck) {
    disqusConfig = {
      url: href + 'food-trucks/' + truck.id,
      identifier: `sft-truck-${truck.id}`,
      title: truck.name,
    };
  } else if (location) {
    disqusConfig = {
      url: href + 'schedule/' + location.slug,
      identifier: `sft-location-${location.slug}`,
      title: location.name,
    };
  }

  return (
    <DiscussionEmbed shortname={disqus_shortname} config={disqusConfig} />
  );
}

DisqusReviews.propTypes = {
  truck: PropTypes.object,
  location: PropTypes.object,
};

export default DisqusReviews;
